declare global {
  interface Window {
    ApplePaySession?: {
      canMakePayments: () => boolean;
    };
  }
}

export const browserName = () => {
  const userAgent = navigator.userAgent;
  let browserName = "";

  if (userAgent.includes("Chrome") && !userAgent.includes("Edge")) {
    browserName = "Chrome";
  } else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
    browserName = "Safari";
  } else if (userAgent.includes("OPR")) {
    browserName = "Opera";
  }

  return browserName;
};

export const isApplePaySupported = (): boolean => {
  if (window?.ApplePaySession && window?.ApplePaySession?.canMakePayments()) {
    return true;
  } else {
    return false;
  }
};
